/**
 * NotFound - A simple 404 page component.
 * @returns {JSX.Element} The 404 not found page.
 */

import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      <div>
        <h1 className="text-5xl py-4">404 - Not Found</h1>
        <p className="text-xl">The page you are looking for does not exist.</p>
        <ul className="flex flex-col py-5 gap-2 text-lg">
          <li>
            <Link to="/dashboard/admin" className="underline text-blue-500">
              Admin panel
            </Link>
          </li>
          <li>
            <Link to="/dashboard/media" className="underline text-blue-500">
              Media
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NotFound;
